<template>
  <div class="print-credentials">
    <div class="print-content" style="margin:30px 0;" id="printTest1">
      <!-- Header Section -->
      <div style="overflow:hidden;width:100%;margin:auto;text-align:center;">
        <el-image
          style="width:45px;float:left"
          :src="require('../assets/image/Logo/logo.png')"
        ></el-image>
        <h1 style="float:left;font-size:26px;margin-top:0;line-height:40px;">
          {{ title || "BNIF-AFUWA" }}
        </h1>
      </div>

      <!-- Table Section -->
      <table style="width:100%;border-collapse:collapse;margin-top:20px;">
        <!-- Table Header -->
        <thead>
          <tr>
            <th style="border:1px solid #000;padding:8px;">N° du Rétrait</th>
            <th style="border:1px solid #000;padding:8px;">Date Envoi</th>
            <th style="border:1px solid #000;padding:8px;">Date Rétrait</th>
            <th style="border:1px solid #000;padding:8px;">
              Type de l'Opération
            </th>
            <th style="border:1px solid #000;padding:8px;">Montant Retiré</th>
            <th style="border:1px solid #000;padding:8px;">Expéditeur</th>
            <th style="border:1px solid #000;padding:8px;">Destinataire</th>
            <th style="border:1px solid #000;padding:8px;">Etat</th>
            <th style="border:1px solid #000;padding:8px;">Agence Envoi</th>
            <th style="border:1px solid #000;padding:8px;">Agence Retrait</th>
            <th style="border:1px solid #000;padding:8px;">Provenance</th>
            <th style="border:1px solid #000;padding:8px;">Destination</th>
          </tr>
        </thead>

        <!-- Table Body -->
        <tbody>
          <tr v-for="(row, index) in tableData" :key="index">
            <td style="border:1px solid #000;padding:8px;">
              {{ row.withdrawMoneyCode }}
            </td>
            <td style="border:1px solid #000;padding:8px;">
              {{ row.remitterCreateTime }}
            </td>
            \
            <td style="border:1px solid #000;padding:8px;">
              {{ row.payeeDoneTime }}
            </td>
            <td style="border:1px solid #000;padding:8px;">
              {{ row.businessTypeName }}
            </td>
            <td style="border:1px solid #000;padding:8px;">
              {{ row.payeeAmount }}
            </td>
            <td style="border:1px solid #000;padding:8px;">
              {{ row.expediteur }}
            </td>
            <td style="border:1px solid #000;padding:8px;">
              {{ row.destinataire }}
            </td>
            <td style="border:1px solid #000;padding:8px;">{{ row.status }}</td>
            <td style="border:1px solid #000;padding:8px;">
              {{ row.remitterOrgName }}
            </td>
            <td style="border:1px solid #000;padding:8px;">
              {{ row.payeeOrgName }}
            </td>
            <td style="border:1px solid #000;padding:8px;">
              {{ row.remitterCity }}
            </td>
            <td style="border:1px solid #000;padding:8px;">
              {{ row.address }}
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Footer Section -->
       <!-- signature -->
      <div style="display:flex;justify-content:space-between;margin-top:40px;padding:0 10px;">
  
  <div style="text-align:center;width:45%;">
    <p style="margin:0 0 45px 0;font-size:13px;">{{ $t("customer") }}</p>
    <div style="border-top:1px solid #000;"></div>
  </div>

  <div style="text-align:center;width:45%;">
    <p style="margin:0 0 45px 0;font-size:13px;">
      {{ loginInfo.name }} {{ loginInfo.surname }}
    </p>
    <div style="border-top:1px solid #000;"></div>
  </div>
</div>

<p style="text-align:right;margin-top:25px;font-size:12px;">
  {{ $manba().format("ymdhms") }}
</p>
    </div>

    <!-- Print Buttons -->
    <div class="print-btn">
      <el-button size="mini" @click="openCallback">{{ $t("close") }}</el-button>
      <el-button type="primary" size="mini" v-print="printConfig">{{
        $t("printrRceipt")
      }}</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: "PrintBatchRecord",
  props: {
    param: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: "BNIF-AFUWA",
    },
    isClosePrint: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      printConfig: {
        id: "printTest1",
        openCallback(vue) {
          vue.printLoading = false;
          vue.openCallback(vue);
        },
      },
    };
  },
  computed: {
    // Transform param into table data
    tableData() {
      if (!this.param || this.param.length === 0) return [];

      return this.param.map((row) => ({
        withdrawMoneyCode: row.withdarwMoneyCode || "N/A",
        remitterCreateTime: this.$manba(row.remitterCreateTime).format(
          "ymdhms",
        ),
        payeeDoneTime: this.$manba(row.payeeDoneTime).format("ymdhms"),
        payeeAmount: `₣ ${row.remitterAmount.replace("-", "").split(".")[0] ||
          0}`,
        businessTypeName: row.businessTypeName || "N/A",
        //frais: `₣ ${row.remitterAmount.replace("-", "").split(".")[0] || 0}`,
        //remise: "0", // Add remise logic if available
        expediteur: `${row.remitterName || ""} ${row.remitterSurname || ""}`,
        destinataire: `${row.payeeName || ""} ${row.payeeSurname || ""}`,
        status: row.status || "N/A",
        remitterOrgName: row.remitterOrgName || "N/A",
        payeeOrgName: row.payeeOrgName || "N/A",
        remitterCity: row.remitterCity || "N/A",
        address: row.address || "N/A",
        Destination: this.param.payeeCity || "",
        purpose: this.param.purpose || "",
        //userRetrait: row.createId || "N/A"
      }));
    },
    loginInfo() {
      return this.$store.state.globalParameter.loginInfo;
    },
  },
  methods: {
    openCallback() {
      this.$emit("update:isClosePrint", !this.isClosePrint);
    },
  },
};
</script>
